import React from 'react';
import { ANCHORED_SHEET_MOBILE, useFeatureFlag } from '@shared/util/featureFlags/launchDarkly';
import { useIsDesktop } from '@shared/util/hooks';
import { AnchoredSheet } from './AnchoredSheet';
import { MBBottomSheetMobile } from './BottomSheetMobile';
import { Props } from './props';

export function MBBottomSheet(props: Props) {
  const isDesktop = useIsDesktop();
  const anchoredSheetMobile = useFeatureFlag(ANCHORED_SHEET_MOBILE);
  if (isDesktop || anchoredSheetMobile) {
    return <AnchoredSheet {...props} />;
  } else {
    return <MBBottomSheetMobile {...props} />;
  }
}
